/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, Container, Grid, Typography, Card, CardHeader } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ScanSensor from '../../components/scan-sensors/scanSensors';
import AddVstDevice from '../../components/add-vst-device/addVstDevice';
import RemoveVstDevice from '../../components/remove-vst-device/removeVstDevice';
import RemoveFile from '../../components/remove-file/removeFile';

export default function NvStreamerManagement() {
  const { adaptorType } = window;
  return (
    <>
      <Helmet>
        <title> Management </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Management
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardHeader title={`Add ${adaptorType} device`} subheader={`Add endpoint for ${adaptorType} device`} />
              <Box sx={{ p: 3, pb: 1 }}>
                <AddVstDevice />
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardHeader
                title={`Remove ${adaptorType} device`}
                subheader={`Remove endpoint for ${adaptorType} device`}
              />
              <Box sx={{ p: 3, pb: 1 }}>
                <RemoveVstDevice />
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardHeader title="Scan files" subheader="Scan for files" />
              <Box sx={{ p: 3, pb: 1 }}>
                <ScanSensor />
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardHeader title="Delete files" subheader="Delete files" />
              <Box sx={{ p: 3, pb: 1 }}>
                <RemoveFile />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
